varying vec2 vUv; 
uniform float u_power;

void main()
{
    vec2 ndc = (vUv -0.5)*2.;
    ndc *=100.;
    ndc = clamp(ndc, 0., 1.);
    gl_FragColor = vec4(vec3(0.1*u_power), 1.);
}